<template>
  <div style="background: #ffffff; height: 100%;height:calc(100vh - 60px);overflow-y:hidden;text-align: center;">
    <el-image  :src="logourl"  fit="contain" style="height:100px;width:130px; margin:30vh auto 0;"></el-image>
    <div style="margin:20px;text-align:center;font-size:20px;color:#333333">
      欢迎使用{{ user.factoryname||'miBEE' }}数字暖通智慧管理平台
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Index',
  data () {
    return {
      user:{},
      logourl: './static/images/logo.png'
    }
  },
  mounted: function () {
    var self = this

    let dealer = window.localStorage.getItem('customer')
    if (dealer) {
     this.user=JSON.parse(dealer)
     if (this.user.logo) {
        this.logourl = 'https://resource.mibee.cn/resource/'+this.user.logo
      }
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'error'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  computed: {

  },
  methods: {
    
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/Welcome.vue